<template>
  <div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <v-flex
      v-if="isLoading"
      justify-center
    >
      <u-loader />
    </v-flex>
    <div v-else>
      <v-card class="card-body">
        <v-container>
          <h5>Bezeichnung</h5>

          <v-text-field
            v-model="holidayNameDE"
            label="Deutsch"
          />
          <v-text-field
            v-model="holidayNameFR"
            label="Französisch"
          />
          <v-text-field
            v-model="holidayNameIT"
            label="Italienisch"
          />
        </v-container>
      </v-card>

      <v-card class="card-body mt-4">
        <v-container>
          <h5>Allgemeine Informationen</h5>

          <u-date-picker
            v-model="date"
            label="Datum"
          />
          <v-select
            v-model="holidayType"
            :items="publicHolidayTypes"
            class="mt-4"
            item-text="text"
            item-value="value"
            label="Feiertagstyp"
          />
        </v-container>
      </v-card>

      <v-card class="card-body mt-4">
        <v-container>
          <h5>Gültigkeitsbereich</h5>
          <u-tree-view
            v-model="selectedLocations"
            :tree-view-items="localisedOptions"
            class="mt-2"
            item-key="path"
            item-children="children"
            :display-feiertags-region-import="true"
          />
        </v-container>
      </v-card>
      <hr class="custom_hr">
      <div class="mt-4">
        <v-btn
          :disabled="
            !selectedLocations.length ||
              !holidayType ||
              !date ||
              !holidayNameDE ||
              !holidayNameFR ||
              !holidayNameIT
          "
          class="btn-left"
          color="success"
          raised
          @click="saveResourceCalendar"
        >
          <i class="fas fa-plus mr-3" /> Neu Erfassen
        </v-btn>

        <v-btn
          color="#e72b37"
          raised
          style="color: white"
          @click="cancel"
        >
          <i class="fas fa-ban mr-3" /> Abbrechen
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import UDatePicker from "@/components/common/UDatePicker.vue";
import UTreeView from "@/components/common/UTreeView.vue";
import {
  GetLocationTree,
  SaveRessourceCalendar,
} from "@/services/minimum.wage.services/resourceCalendar.minimum.wage";
import {
  CreateTreeViewObject,
  ValidateTreeView,
  GetOptionIdsForOptionPaths,
} from "@/helpers/TreeViewHelperResourceCalendar.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  components: {
    UDatePicker,
    UTreeView,
  },
  mixins: [MinimumWageMixin],
  props: {
    publicHolidayTypes: {
      type: Array,
      default: () => [],
    },
    localisedOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      holidayNameDE: "",
      holidayNameFR: "",
      holidayNameIT: "",
      date: null,
      holidayType: 1,
      validForCH: false,
      selectedLocations: [],
      locationOptions: [],
      fullLocationTree: null,
      isLoading: false,
      errorObject: null,
    };
  },
  created() {
    this.GetAllLocationOptions();
  },
  methods: {
    GetAllLocationOptions() {
      this.isLoading = true;
      GetLocationTree(
        false,
        (response) => {
          const validatedTreeView = ValidateTreeView(response);
          this.locationOptions = validatedTreeView.treeItems;
          this.selectedLocations = validatedTreeView.selectedItems;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    saveResourceCalendar() {
      this.isLoading = true;
      let selectedLocationIds = GetOptionIdsForOptionPaths(
        this.locationOptions[0].children,
        this.selectedLocations,
      );
      const locationTree = CreateTreeViewObject(
        this.locationOptions[0].children,
        selectedLocationIds,
        this.editionId,
        this.holidayType,
      );

      let newResourceCalendar = {
        id: 0,
        date: new Date(this.date),
        configurationId: this.editionId,
        publicHolidayType: this.holidayType,
        ressourceCalendarContents: [
          {
            id: 0,
            ressourceCalendarId: 0,
            holidayDescription: this.holidayNameDE,
            language: "de-CH",
          },
          {
            id: 0,
            ressourceCalendarId: 0,
            holidayDescription: this.holidayNameFR,
            language: "fr-CH",
          },
          {
            id: 0,
            ressourceCalendarId: 0,
            holidayDescription: this.holidayNameIT,
            language: "it-CH",
          },
        ],
        ressourceCalendarConfigurationPublicHolidayTypes: [],
        locationTree: locationTree,
      };

      SaveRessourceCalendar(
        newResourceCalendar,
        () => {
          this.clearInputs();
          this.$emit("saved");
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    cancel() {
      this.clearInputs();
      this.$emit("canceled");
    },
    clearInputs() {
      this.errorObject = "";
      this.holidayNameDE = "";
      this.holidayNameFR = "";
      this.holidayNameIT = "";
      this.date = "";
      this.holidayType = 1;
      this.selectedLocations = [];
    },
  },
};
</script>
<style scoped></style>
